import { render } from "./ConsultaPedidoChat.vue?vue&type=template&id=05a33d50"
import script from "./ConsultaPedidoChat.vue?vue&type=script&lang=js"
export * from "./ConsultaPedidoChat.vue?vue&type=script&lang=js"

import "./ConsultaPedidoChat.vue?vue&type=style&index=0&id=05a33d50&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__